<script lang="ts" setup>
import { CustomerMgmtTypes, useEditUser } from '@ilteducation/customer-mgmt';
import { SelfConfirmTextField } from '@ilteducation/text-field/self-confirmed-text-field';
import { nonRequiredMinLength } from '../../../../rules/index';
import { useLocale } from '../../../../composables/useLocale';
import { createErrorParser } from '../../../../error-utils';
import { ref } from 'vue';

type Props = {
  loading?: boolean;
  disabled?: boolean;
  user: CustomerMgmtTypes.GetUserResponse;
};
const props = defineProps<Props>();

const { t } = useLocale();
const { updateUser, isLoading, error } = useEditUser();

const requestErrorMessage = ref<string>();
const savePassword = async (newPassword: string) => {
  if (!props.user) return false;

  requestErrorMessage.value = undefined;
  const successful = await updateUser(props.user.uid, { password: newPassword });

  if (!successful) {
    requestErrorMessage.value = createErrorParser(t)(error.value);
  }

  return successful;
};
</script>

<template>
  <SelfConfirmTextField
    prepend-inner-icon="mdi-key-variant"
    type="password"
    :label="t('lcp.password')"
    :show-password-label="t('lcp.show_password')"
    :hide-password-label="t('lcp.hide_password')"
    :disabled="disabled || loading"
    :loading="isLoading || loading"
    :onApprove="savePassword"
    :rules="[nonRequiredMinLength(8, t)]"
    :color="requestErrorMessage ? 'error' : undefined"
    :messages="requestErrorMessage"
  >
    <template v-if="requestErrorMessage" v-slot:message>
      <!--
      Why not error-message but force message to looks like error?
      SelfComfirmedText has a comfirmation button gets disabled if validation fails. Veutify validation accepts "error-messages" as validation error.
      Therefore users lose oppurtunity to try again on an error.
       -->
      <div class="text-error text-caption">{{ requestErrorMessage }}</div>
    </template>
  </SelfConfirmTextField>
</template>
